import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
export default function Login() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  async function handleSubmit(e) {
    e.preventDefault(); setError(''); setLoading(true)
    const err = await signIn(email, password)
    if (err) setError(err.message)
    setLoading(false)
  }
  return (
    <div className="auth-page"><div className="auth-bg" />
      <div className="auth-card">
        <div className="auth-logo">DRAGONCLAW<span>AI CODE INTELLIGENCE</span></div>
        <p className="auth-subtitle">Sign in to your account</p>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="field"><label>Email</label><input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" required /></div>
          <div className="field"><label>Password</label><input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required /></div>
          <button className="btn-fire" type="submit" disabled={loading}>{loading?'SIGNING IN…':'SIGN IN'}</button>
        </form>
        <p className="auth-switch">No account? <span onClick={()=>window.location.href='/signup'}>Create one</span></p>
      </div>
    </div>
  )
}
